import axios from 'services/axios'
import { API_HS_DOWNLOAD, API_HS_LIST } from 'constants/endpoints'

// Models
import Category from 'models/Category'

/**
 * Get icon file
 *
 * @param {String} url
 * @return {Blob}
 */
export const getIconFile = async (id) => {
  try {
    const { data } = await axios.post(
      API_HS_DOWNLOAD,
      {
        id,
        type: 'icon',
      },
      {
        responseType: 'blob',
      }
    )
    return data
  } catch (error) {
    return null
  }
}

/**
 * Get data list
 * @param {String} url
 * @returns {Object}
 */

export const getListCategory = async () => {
  try {
    const { data } = await axios.get(API_HS_LIST)

    const list = data.map((x) => {
      return new Category(x)
    })

    // Get icon
    for (const x of list) {
      x.iconFile = x.iconName ? await getIconFile(x.id) : null
    }

    return list
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Open File
 *
 * @param {String} id
 */
export const openGuideFile = async (id) => {
  try {
    return await axios.post(
      API_HS_DOWNLOAD,
      {
        id,
        type: 'guide-file',
      },
      {
        viewFile: true,
      }
    )
  } catch (error) {
    return Promise.reject(error)
  }
}
